/**
 * 检测任务国际化
 * date：2022 05 10
 */

export default {
  task: {
    CheckSensorBreakdown: 'Check Sensor Connection',
    CheckGatewayBreakdown: 'Check Gateway Connection',
    CheckRelayBreakdown: 'Check Repeater Connection',
    CheckDisplayBreakdown: 'Check Display Connection',
    zbp_sensor_off: 'ZBP Temp&RH Sensor Offline Detection',
    zbp_v2_sensor_off: 'ZBP V2.0 Sensor Offline Detection',
    '4g_sensor_off': '4G Sensor Offline Detection',

    lora_sensor_off: 'LoRa Temp&RH Sensor Offline Detection',
    zeta_sensor_off: 'ZETA Temp&RH Sensor Offline Detection',
    gateway_1_off: 'Gateway V1.0 Offline Detection',
    display_1_off: 'Display V1.0 Offline Detection',
    relay_1_off: 'Repeater V1.0 Offline Detection',
    task_detection_status_stop: 'Stop',
    task_detection_status_running: 'Running',
    detection_interval_minute: 'min',
    detection_interval_hour: 'hour',
    detection_interval_day: 'days'
  }
}
